import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class BaseService {
  protected baseUrl: string;

  constructor(protected http: HttpClient) {
    //this.baseUrl = environment.ApiUrl;
    this.baseUrl = '';
  }

  protected get<type>(url: string): Observable<any> {
    if(this.checkURLHasParran(url))
      url += '&'+ this.getDateTimeUnix();
    else
      url += '?'+ this.getDateTimeUnix();
    return this.http.get(this.baseUrl + url )
      .catch(this.handleError);
  }

  protected post<Type>(url: string, data: Type, options?: any):Observable<any> {
    return this.http.post(this.baseUrl + url, data, options)
      .catch(this.handleError);
  }

  protected handleError(error: HttpErrorResponse) {
    // if (error.status === 400)
    //     return Observable.throw(error.error.details);
    // else
    return Observable.throw(error);
  }

  getDateTimeUnix():number{
    return new Date().getMilliseconds();
  }

  checkURLHasParran(url:string):boolean{
    if(url == undefined || url == '' || url.split('?').length < 2)
      return false;
    return true;
  }
}
